import { render, staticRenderFns } from "./Formas_Creacion_FormatoConvenio.vue?vue&type=template&id=4fb80890&scoped=true"
import script from "./Formas_Creacion_FormatoConvenio.vue?vue&type=script&lang=js"
export * from "./Formas_Creacion_FormatoConvenio.vue?vue&type=script&lang=js"
import style0 from "./Formas_Creacion_FormatoConvenio.vue?vue&type=style&index=0&id=4fb80890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb80890",
  null
  
)

export default component.exports